function RecommendedPostWeb({ data, Link }) {
  return (
    <>
      <section className="recommended-posts web">
        <h2 className="recommended-title">Recommended Posts</h2>
        <div className="recommended-grid">
          {data?.recommended?.map((post, index) => (
            <div className="recommended-card pointer-crusser" key={index}>
              <Link to={`/blog/${post?.action_url}`}>
                <img src={post?.media} alt="Post 1" />
              </Link>
              <p className="relet-post-name">{post?.name}</p>
              <div className="txt_btn_recomend">
                <p>
                  Posted on{" "}
                  {new Date(post?.created_at).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </p>
                <Link to={`/blog/${post?.action_url}`}>
                  <u>Read More</u>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  )

}
export default RecommendedPostWeb;